import { Box, Checkbox, Divider, Typography } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import React, { useState, useEffect } from "react";

export function EditRole({
  handleSubmit,
  isDisabled,
  isFormModified,
  handleRolePermitList = [],
  handlePermiByRolList = [], // lista de permisos asociados al rol
  role,
  handleFieldChange,
  handleUpdatePermissions, // Prop para manejar la actualización de permisos desde el controlador
  isFieldValid,
}) {
  const [selectedPermissions, setSelectedPermissions] = useState([]);

  useEffect(() => {
    // Obtener una lista de permission_id desde handlePermiByRolList
    const permissionIdsByRole = handlePermiByRolList.map((permission) => permission.permission_id);

    // Filtrar los permisos que están en ambas listas y establecerlos como seleccionados
    const initialSelectedPermissions = handleRolePermitList
      .filter((permission) => permissionIdsByRole.includes(permission.id))
      .map((permission) => permission.id);

    setSelectedPermissions(initialSelectedPermissions);
  }, [handleRolePermitList, handlePermiByRolList]);

  const handlePermissionChange = (event, permissionId) => {
    // Encontrar el permiso actual
    const currentPermission = handleRolePermitList.find(p => p.id === permissionId);

    let updatedPermissions;

    if (event.target.checked) {
      // Si se está seleccionando un permiso
      updatedPermissions = [...selectedPermissions, permissionId];

      // Validación para permisos mutuamente excluyentes de actividades
      if (currentPermission?.module === 'Actividades') {
        if (currentPermission.name === 'Listar mis actividades') {
          // Si se selecciona "Listar mis actividades", quitar "Listar todas las actividades"
          const listarTodasId = handleRolePermitList.find(
            p => p.name === 'Listar todas las actividades' && p.module === 'Actividades'
          )?.id;
          if (listarTodasId && updatedPermissions.includes(listarTodasId)) {
            updatedPermissions = updatedPermissions.filter(id => id !== listarTodasId);
          }
        } else if (currentPermission.name === 'Listar todas las actividades') {
          // Si se selecciona "Listar todas las actividades", quitar "Listar mis actividades"
          const listarMisId = handleRolePermitList.find(
            p => p.name === 'Listar mis actividades' && p.module === 'Actividades'
          )?.id;
          if (listarMisId && updatedPermissions.includes(listarMisId)) {
            updatedPermissions = updatedPermissions.filter(id => id !== listarMisId);
          }
        }
      }
    } else {
      // Si se está deseleccionando un permiso
      updatedPermissions = selectedPermissions.filter((id) => id !== permissionId);
    }

    setSelectedPermissions(updatedPermissions);

    // Mostrar en consola el JSON con los permisos seleccionados
  };

  // Obtener todos los tipos de permisos únicos y ordenarlos alfabéticamente
  const allPermissionTypes = Array.from(
    new Set(handleRolePermitList.map((permission) => permission.name))
  ).sort((a, b) => a.localeCompare(b));

  // Configuración de las columnas
  const columns = [
    { Header: "Recurso", accessor: "resource", align: "center" },
    ...allPermissionTypes.map((type) => ({
      Header: type,
      accessor: type,
      align: "center",
    })),
  ];

  // Configuración de las filas - ordenar módulos alfabéticamente
  const rows = Object.entries(
    handleRolePermitList.reduce((acc, permission) => {
      const moduleName = permission.module;
      if (!acc[moduleName]) {
        acc[moduleName] = { resource: moduleName };
      }
      acc[moduleName][permission.name] = (
        <Checkbox
          checked={selectedPermissions.includes(permission.id)}
          onChange={(event) => handlePermissionChange(event, permission.id)}
          sx={{
            color: "#424242",
            '&.Mui-checked': {
              color: "#1976d2",
            },
            '& .MuiSvgIcon-root': {
              fontSize: 24,
              border: "1px solid #424242",
              borderRadius: "4px",
            },
            '&:hover': {
              backgroundColor: 'rgba(25, 118, 210, 0.08)',
            }
          }}
        />
      );
      return acc;
    }, {})
  )
    .sort(([moduleA], [moduleB]) => moduleA.localeCompare(moduleB))
    .map(([module, data]) => data);

  return (
    <>
      <Divider variant="middle" />
      <form onSubmit={handleSubmit}>
        <Box>
          <MDBox
            style={{
              display: "flex",
              justifyContent: "space-around",
            }}
          >
            <MDBox style={{ width: "50%" }}>
              <MDTypography
                component="h5"
                style={{ marginTop: "5px", width: "50%" }}
              >
                Ajustar rol
              </MDTypography>
              <MDBox
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "5px",
                  width: "100%",
                }}
              >
                <MDInput
                  value={role?.name}
                  error={!isFieldValid.name}
                  helperText={
                    role?.name === "" && !isFieldValid.name
                      ? "El campo no puede estar vacío"
                      : !isFieldValid.name
                        ? "No se permiten números ni caracteres especiales"
                        : ""
                  }
                  FormHelperTextProps={{ className: !isFieldValid.name ? "Mui-error" : "" }}
                  onChange={(e) => handleFieldChange("name", e.target.value)}
                  style={{ flexGrow: 1 }}
                />
                {/* <MDButton
                  type="submit"
                  disabled={!isFormModified}
                  color="success"
                  style={{ marginLeft: "10px" }}
                >
                  Guardar
                </MDButton> */}
              </MDBox>
            </MDBox>
          </MDBox>
        </Box>
        <Divider variant="middle" />
      </form>

      <DataTable
        table={{ columns, rows }}
        canSearch={false}
        isSorted={false}
        entriesPerPage={false}
        showTotalEntries={false}
      />
      {/* Botón para actualizar los permisos */}
      <MDBox
        style={{
          display: "flex",
          justifyContent: "center",
          margin: "20px",
        }}
      >
        <MDButton onClick={() => handleUpdatePermissions(selectedPermissions)} color="success">
          Actualizar
        </MDButton>
      </MDBox>
    </>
  );
}
